'use strict';
var AskOurExpertsController = /** @class */ (function () {
    /*@ngInject*/
    function AskOurExpertsController($scope, AskOurExpertsService, UserService, EducationSubNavService, $anchorScroll, $location, $timeout, $mdToast, $stateParams) {
        var _this = this;
        this.title = ["Date", "Topics", "Subjects"];
        this.pageCount = function () {
            var itemsPerPage = 10;
            var items = [];
            return Math.ceil(10 / itemsPerPage) - 1;
        };
        this.range = function (startFrom, rangeSize) {
            var ret = [];
            for (var i = startFrom; i < startFrom + rangeSize; i++) {
                ret.push(i);
            }
            return ret;
        };
        this.pageNumberClick = function (index) {
            var _this = this;
            this.AskOurExpertsService.getDoctorQuestion(this.currentPageIndex)
                .then(function (response) {
                if (response.currentPage.length > 0) {
                    _this.pageinationContentLength = response.currentPage.length;
                    if (_this.pageinationSize < _this.maxPageinationSize && index > _this.currentPageIndex && index - _this.pageinationSize == 1) {
                        _this.pageinationSize++;
                    }
                }
                _this.currentPageIndex = index > 0 ? index : 1;
                if (_this.currentPageIndex > _this.maxPageinationSize - 1) {
                    _this.pageinationStartFrom = _this.currentPageIndex - _this.maxPageinationSize;
                }
                _this.data_colomn = response;
            });
        };
        this.submitQuestion = function () {
            var _this = this;
            var productName = this.stateParams.productName;
            var itemCode = this.stateParams.itemCode;
            var questionObj = {
                'questionText': (productName && itemCode) ?
                    productName + ', ' + itemCode + ' - ' + this.question : this.question,
                'topic': null,
                'emailAddress': this.user.email,
                'keywords': null
            };
            var self = this;
            this.AskOurExpertsService.postDoctorQuestion(questionObj)
                .then(function (response) {
                if (_this.question) {
                    _this.showSimpleToast("Thank you for your question. Our team of experts will reply to your inquiry within 1-2 business days.", '');
                }
                _this.question = '';
                _this.stateParams = {};
            })
                .catch(function (err) {
                _this.question = '';
                _this.showSimpleToast("Your question is not submitted.", '');
            });
        };
        $scope.$ctrl.value.selectedpageindex = 2;
        $scope.$ctrl.value.level = '2';
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '2';
        this.question = '';
        this.AskOurExpertsService = AskOurExpertsService;
        this.UserService;
        this.currentPageIndex = 1;
        this.maxContentPerPage = 10;
        this.$mdToast = $mdToast;
        this.setDisclaimerContentPara1();
        this.$mdToast = $mdToast;
        this.gotoAnchor = function (hashVal) {
            $timeout(function () {
                $location.hash(hashVal);
                $anchorScroll();
            }, 200);
        };
        this.stateParams = $stateParams;
        AskOurExpertsService.getDoctorQuestion(this.currentPageIndex)
            .then(function (response) {
            if (response.currentPage.length > 0) {
                _this.pageinationContentLength = response.currentPage.length;
                _this.pageinationSize = 1;
                _this.maxPageinationSize = 10;
                _this.pageinationStartFrom = 0;
                _this.showPageination = true;
            }
            _this.data_colomn = response;
        });
        UserService.get().then(function (user) {
            _this.user = user.data.response;
        });
    }
    AskOurExpertsController.prototype.setDisclaimerContentPara1 = function () {
        this.disclaimerContentPara1 = "<span class=\"disclaimerContent-head\">Disclaimer </span>The contents of the Emerson Ecologics website, such as text, graphics, images and other material contained on the website (\"Content\") are for informational purposes only. \n    The Content is not intended to be a substitute for professional medical advice, diagnosis or treatment and we do not provide specific product recommendations for specific medical conditions. We maintain a third-party database on our website called \u201CClinical Essentials.\n    \u201D Clinical Essentials Content can be accessed by logging in to our website (www.emersonecologics.com) and then clicking on the \"Practitioner Resource Center\" link on the upper right corner of the Homepage. Once you have accessed the Practitioner Resource Center you will \n    have the option to access Clinical Essentials. Clinical Essentials Content provides fully cross-referenced information on over 125 Health Conditions, 150 Botanicals and 150 Nutritional Supplements. In addition, you will find information on over 5,000 positive and negative potential \n    Drug Depletions & Interactions between more than 800 OTC and prescription drugs, herbs and supplements. Consumers and customers should always be encouraged to seek the advice of a physician or other qualified health provider with any questions regarding a medical condition. \n    Clinical Essentials does not recommend specific products, rather the information and materials cover a wide variety of descriptions of ingredients and are general in terms of their indications. However, it is possible to find products described on the website that contain \n    the ingredients that are recommended in many of our offered products. Quality and Emerson\u2019s Medical Educators can assist you in finding products with the ingredients described in the Clinical Essentials section. Additionally, our Medical Educators are available for consultation with an appointment. \n    Other than personally identifiable information, which is subject to this Website's Privacy Statement, any material, information, suggestions, ideas, concepts, know-how, techniques, questions, comments or other communication you transmit or post to this website in any manner (\"User Communications\") \n    is and will be considered non-confidential and non-proprietary. Personally identifiable information should not be used that may identify a patient and you should not provide any specific patient treatment recommendation or information. Information that you voluntarily post on any part of this \n    website that is viewable by the public (e.g., in the Customer Reviews section) is not subject to this website's Privacy Statement and is considered User Communications. We and our respective affiliates and our or their designees may use any or all User Communications for any purpose whatsoever, \n    including, without limitation, reproduction, transmission, disclosure, publication, broadcast, development, manufacturing and/or marketing in any manner whatsoever for any or all commercial or non-commercial purposes. We may, but are not obligated to, monitor or review any User Communications. \n    We will have no obligation to use, return, review or respond to any User Communications. We will have no liability related to the content of any such User Communications, whether or not arising under the laws of copyright, libel, privacy, and obscenity or otherwise. We retain the right to remove \n    any or all User Communications that includes any material we deem inappropriate or unacceptable.";
    };
    AskOurExpertsController.prototype.showSimpleToast = function (message, addMsg) {
        var msg = (addMsg != null) ? addMsg : '';
        this.$mdToast.show(this.$mdToast.simple()
            .textContent(message + ' \n' + msg)
            .parent(document.querySelectorAll('#rx-toast'))
            .position('top right')
            .hideDelay(2000));
    };
    return AskOurExpertsController;
}());
export default AskOurExpertsController;
//# sourceMappingURL=ask-our-experts.controller.js.map